export var emptyMasterData = {
    accessLevel: [],
    businessAreas: [],
    paymentTypes: [],
    petTypes: [],
    ageOptions: [],
    petAges: [],
    petSizes: [],
    dogHairTypes: [],
    dogHairLengths: [],
    catHairTypes: [],
    catHairLengths: [],
    catColors: [],
    dogColors: [],
    exoticColors: [],
    petExoticTypes: [],
    petGenders: [],
    grooming: {
        visibility: [],
        holdingAreas: [],
        sizeSeparation: [],
        security: [],
        locationTypes: [],
    },
    daycare: {
        visibility: [],
        sizeSeparation: [],
        recreationalPerks: [],
        security: [],
        extras: [],
    },
    boarding: {
        visibility: [],
        sizeSeparation: [],
        facilityTours: [],
        overnightCare: [],
        recreationalPerks: [],
        security: [],
        extras: [],
    },
    staff: {
        training: [],
    },
    status: [],
    serviceTags: [],
    roles: [],
    relationships: [],
    dentalReportOptions: {
        dentalProcedures: [],
        homecare: [],
        periodontalFindings: [],
        recommendations: [],
        toothAbnormalities: [],
    },
    groomingReportOptions: {
        skin: [],
        teeth: [],
        nails: [],
        coat: [],
        ears: [],
        eyes: [],
        behavior: [],
        findings: [],
        recommendations: [],
        findingPlaces: [],
    },
    breeds: {
        dogs: [],
        cats: [],
        exotics: [],
    },
    medicalHistory: {
        dentals: [],
        medicalConditionCategories: [],
        behaviorConditionCategories: [],
    },
    petRequirements: [],
    imagesMaxSizes: {
        groomingReportMaxKb: 2048,
        dentalReportKb: 2048,
        squareLogoKb: 2048,
        squareLogo: {
            maxSizeKb: 2048,
            maxWidthPx: 600,
            maxHeightPx: 600,
            imageTypes: ["png", "jpg"],
        },
        horizontalLogoKb: 2048,
        horizontalLogo: {
            maxSizeKb: 2048,
            maxWidthPx: 500,
            maxHeightPx: 200,
            imageTypes: ["png", "jpg"],
        },
        avatarKb: 2048,
        onlineBookingImage: {
            maxSizeKb: 2048,
            maxWidthPx: 980,
            maxHeightPx: 1200,
            imageTypes: ['png', 'jpg'],
        },
    },
    vaccines: [],
    emailContent: [],
    productUnits: [],
    payments: {
        phoneTypes: [],
        documentTypes: {
            shareholder: [],
            businessProfile: [],
            bankAccount: [],
        },
        genders: [],
        shareholderTypes: [],
        verificationStatuses: [],
        refundStatuses: [],
        bankAccountTypes: [],
        bankAccountCountries: [],
        currencies: [],
        files: {
            pdf: { maxSizeBytes: 0, minSizeBytes: 0 },
            image: { maxSizeBytes: 0, minSizeBytes: 0 },
        },
        statuses: [],
        paymentMethods: [],
    },
    usStates: [],
    caStates: [],
    countryCodes: [],
    countries: [],
    smsCampaignsStatus: [],
    scheduleDuration: [],
    scheduleFrecuency: [],
    orderStatuses: [],
    terminalsModels: [],
    clientTags: {
        positive: [],
        negative: [],
    },
    taxOptions: [],
    hearAboutUsOptions: [],
    agreementsSendTo: [],
    timeZones: [],
    resourceAccessPlans: [],
    resourceAccessLevels: [],
    subscriptionPlans: [],
    olbFromLimits: [],
    olbToLimits: [],
    commissions: {
        categories: [],
        cadences: [],
    },
    locations: [],
    groomers: [],
    softwares: [],
    services: [],
    workflow: [],
    blockFrequencies: [],
    cancelationReasons: [],
    petPositivePersonality: [],
    petNegativePersonality: [],
    serviceColors: [],
    defaultContentNotifications: [],
    notificationPlaceholders: [],
    enrollmentTypes: [],
    rolloverUsages: [],
    enrollmentBillingFrequencies: [],
};
